export default __webpack_public_path__ + "/assets/hero-image.png";